var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7853 9.15173C17.6367 10.34 18.3307 11.4502 18.7424 12.7759C19.0053 13.6224 19.1529 14.5571 19.1529 15.6563C19.1529 18.4684 15.7633 22 12.2281 22C8.69288 22 4.72168 19.3283 4.72168 15.1718C4.72168 11.0158 7.40029 8.68257 8.40249 7.22982C8.95375 6.43065 11.2554 3.64648 11.8872 2C11.8872 2 13.0661 3.803 14.2058 5.49679",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82129 14.8814C7.82129 14.8814 7.96648 15.8015 8.5962 16.7701C9.22551 17.7384 10.0489 18.2714 10.0489 18.2714",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.6f5226a4904c163300f03a3c9968a333.svg";
export { ForwardRef as ReactComponent };